import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from './../../../_config/config';

import { Section } from './argument/argument.model';
import { ArgumentService } from './argument/argument.service';
import { DataGridService } from './data-grid/data-grid.service';

@Injectable({
  providedIn: 'root'
})
export class QueryService {

  gateway = this.config.gateway;

  url= `${this.gateway.urlQuery}/lbw/escenario`;
  urlEscenario= `${this.gateway.urlQuery}/lbw/escenario`;
  
  urlTem= `${this.gateway.urlTemplate}/lbw/template`;

  urlConsulta= `${this.gateway.urlQuery}/lbw/consulta`;

  urlReports= `${this.gateway.urlReport}/lbw/reportes`;

  constructor(private http: HttpClient,
              private argumentService: ArgumentService,
              private dataGridService: DataGridService,
              private config: CONFIG) { }

  onGetJasper(reportid: string, args: any, format:string, queryid:string) {
    args.LOGON_NAME = sessionStorage.getItem('logonName');
    args.queryid = queryid;
    const bodyparams = {
      "reportName": reportid,
      "parameters": args
    };
    console.log('exportJasper' , bodyparams);
    return this.http.post(`${this.urlReports}/export/${format}`, bodyparams, { responseType: "arraybuffer" });
  }

  onGetJasperTemplate(objectReportTemplate: any){
    return this.http.post(`${this.urlTem}/export/exporttemplate`, objectReportTemplate, { responseType: "arraybuffer" });
  }

  // Rembe
  onGetLocalXls(queryId: string, basedonId: string, args: any) {
    const bodyparams = {
      "queryId": queryId,
      "basedonId": basedonId,
      "headerQueryId": '',
      "headerQueryBasedOnId": '',
      "type": "xls",
      "args": args
    };
    return this.http.post(`${this.url}/report/localXls`, bodyparams);
  }


  /// servicios adicionales
  /// Obtener escenarios de la consulta
  getScenarios(queryid: string, basedonid: string, action = 'query') {
    // obtener escenarios del query seleccionado.

    try {
      // let urlJson = 'assets/data/scenarios.json'; // ruta temporal
      let paramsbody;
      paramsbody = {
        queryid,
        basedonid
      };
      console.log("Escenarios: ", paramsbody);
      return this.http.post(`${this.urlEscenario}/scenario/byquery`, paramsbody);
      // console.log('Solicitud Escenarios');
      // return this.http.get(urlJson);

    } catch (error) {
      console.log('Error scenarios');
    }
  }

  onToFormGroup(sections: Section[]): FormGroup {
    return this.argumentService.onToFormGroup(sections);
  }

  exportPDF(object){
    return this.http.post(`${this.urlReports}/export/pdf`, object);
  }



  onGetDataMacro(queryid: string, args: any){
    return this.dataGridService.onGetDataMacro(queryid, args);
  }

  //Rembe
   onGetDataGrafic(data, param){
     let object = {
      data: data,
      filter: param
     }
    return this.http.post(`${this.urlConsulta}/query/parametersGrafic`, object);
  }

  onGetPrintLabel(objectPrintLabel){
    return this.http.post(`${this.urlConsulta}/query/PrintEtiqueta`, objectPrintLabel);
  }

  onGetComponentPetrofisica(queryid, listArguments){
    let argFind = listArguments.find(item => item.argid === '[atributos]' ) ;
    let object = {
      queryId: queryid,
      level: 0,
      atributos: argFind.argdata.replaceAll("'",'').split(','),
      args: listArguments
     }
    return this.http.post(`${this.urlConsulta}/query/getPetrofisicaComponentes1`, object);
  }

  onGetConnection(object){
    return this.http.post(`${this.urlConsulta}/session/connection`, object);
  }
}



